import type { UseFetchOptions } from 'nuxt/app'

export function useFetchLocale<T>(
  url: MaybeRef<string> | (() => MaybeRef<string>),
  options?: UseFetchOptions<T>
) {
  const { locale } = useI18n()

  return useFetch(url, {
    ...options,
    headers: computed(() => ({
      ...options?.headers,
      'Accept-Language': locale.value || 'ru'
    }))
  })
}
